import { useGrowGuide } from '../hooks/useGrowGuide';
import { useGrowGuideUserGuideExperiment } from '../hooks/useGrowGuideUserGuideExperiment';
import { GrowGuideButton } from './GrowGuideButton';
import { UserGuideButton } from './UserGuideButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const GrowGuideContainer = () => {
  const {
    shouldRenderGrowGuide
  } = useGrowGuide();
  const {
    shouldRenderGrowGuideUserGuideExperiment
  } = useGrowGuideUserGuideExperiment();
  if (shouldRenderGrowGuide) {
    return /*#__PURE__*/_jsx(GrowGuideButton, {});
  }
  if (shouldRenderGrowGuideUserGuideExperiment) {
    return /*#__PURE__*/_jsx(UserGuideButton, {});
  }
  return null;
};